import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DoctorUnavailablityApi} from '../api/DoctorUnavailability.api';
import { switchMap, map } from 'rxjs/operators';
import { DoctorUnavailablityData,DoctorUnavailablity } from '../../../interfaces/masters/DoctorUnavailablity';

@Injectable()
export class DoctorUnavailablityService extends DoctorUnavailablityData {

  constructor(private api: DoctorUnavailablityApi) {
    super();
  }


  list(): Observable<DoctorUnavailablity[]> {
    return this.api.list();
  }

  getById(url:string): Observable<DoctorUnavailablity>{
      return this.api.getById(url);
  }

  create(url: string, data:DoctorUnavailablity): Observable<DoctorUnavailablity> {
    return this.api.add(url,data);
  }

  update(url: string, data:DoctorUnavailablity): Observable<DoctorUnavailablity> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
